"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    TTL: "Time-to-live is a value in seconds that indicates how long a record should be cached for before being checked again",
};
